import { render } from "./previewPage.vue?vue&type=template&id=f42e720c&scoped=true"
import script from "./previewPage.vue?vue&type=script&lang=js"
export * from "./previewPage.vue?vue&type=script&lang=js"

import "./previewPage.vue?vue&type=style&index=0&id=f42e720c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f42e720c"]])

export default __exports__